import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    steps: {
        entities: {},
        ids: [],
    },
    currentStepIndex: -1,
    highWaterMark: 0,
    forks: {
        entities: {},
        ids: [],
    },
};
const timelinesSlice = createSlice({
    name: 'timelines',
    initialState,
    reducers: {
        addStep(state, action) {
            const step = action.payload;
            state.steps.entities[step.id] = step;
            if (!state.steps.ids.includes(step.id)) {
                state.steps.ids.push(step.id);
            }
            state.currentStepIndex = state.steps.ids.length - 1;
            if (state.steps.ids.length > state.highWaterMark) {
                state.highWaterMark = state.steps.ids.length;
            }
        },
        setCurrentStep(state, action) {
            const index = action.payload;
            if (index >= -1 && index < state.steps.ids.length) {
                state.currentStepIndex = index;
            }
        },
        clearSteps(state) {
            state.steps.entities = {};
            state.steps.ids = [];
            state.currentStepIndex = -1;
            state.highWaterMark = 0;
        },
        setHighWaterMark(state, action) {
            state.highWaterMark = action.payload;
        },
        addFork(state, action) {
            const fork = action.payload;
            state.forks.entities[fork.id] = fork;
            if (!state.forks.ids.includes(fork.id)) {
                state.forks.ids.push(fork.id);
            }
        },
        removeFork(state, action) {
            const id = action.payload;
            delete state.forks.entities[id];
            state.forks.ids = state.forks.ids.filter((fid) => fid !== id);
        },
        clearForks(state) {
            state.forks.entities = {};
            state.forks.ids = [];
        },
    },
});
export const { addStep, setCurrentStep, clearSteps, setHighWaterMark, addFork, removeFork, clearForks } = timelinesSlice.actions;
export default timelinesSlice.reducer;
//# sourceMappingURL=timelinesSlice.js.map